import Button from 'components/Button';
import classNames from 'styles/utils/classNames';
import StepHeader from './StepHeader';
import BookingDetailsCard from '../BookingDetailsCard';
import CourtList from '../CourtList';
import { BookableCourt } from '../types';

interface Props {
  onBack: () => void;
  courts: BookableCourt[];
  selectedCourtId: string | null;
  onCourtSelect: (courtId: string) => void;
  dateLabel: string;
  timeLabel: string;
  onConfirm: () => void;
  className?: string;
}

/** Step 2: pick which court the chosen times are booked on. */
export default function SelectCourtStep({
  onBack,
  courts,
  selectedCourtId,
  onCourtSelect,
  dateLabel,
  timeLabel,
  onConfirm,
  className,
}: Props) {
  return (
    <div className={classNames('flex flex-col', className)}>
      <StepHeader title="Select from available courts" onBack={onBack} />

      <div className="flex flex-col gap-ds-lg overflow-y-auto px-ds-xl">
        <BookingDetailsCard dateLabel={dateLabel} timeLabel={timeLabel} />
        <CourtList
          courts={courts}
          selectedCourtId={selectedCourtId}
          onCourtSelect={onCourtSelect}
          title={null}
        />
      </div>

      <div className="p-ds-xl pt-ds-lg">
        <Button
          variant="brand"
          size="lg"
          label="Book now"
          disabled={!selectedCourtId}
          onClick={onConfirm}
        />
      </div>
    </div>
  );
}
